

/**
 * @fileoverview Connect signature field values to escaped HTML and explicit clipboard writes. The form owns input state and preview consumers own display. Copy results report browser clipboard success rather than installation in an email provider. `signature-schema.js` owns the shared field vocabulary.
 */

export const generateSignatureHtml = (data) => {
  const { name, title, isAttorney, licenseStates, officePhone, mobilePhone, email, address } = data;

  const renderLicensingInfo =

  () => {
    if (!isAttorney || !licenseStates || licenseStates.length === 0) {
      return '';
    }

    const statesWithLicenses = licenseStates.filter(ls => ls.state && ls.state.trim());
    if (statesWithLicenses.length === 0) {
      return '';
    }

    const stateNames = statesWithLicenses.map(ls => ls.state).join(' and ');
    
    const getStateAbbreviation =

    (stateName) => {
        const stateMap = {
          'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
          'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
          'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
          'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
          'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS',
          'missouri': 'MO', 'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH',
          'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC',
          'north dakota': 'ND', 'ohio': 'OH', 'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA',
          'rhode island': 'RI', 'south carolina': 'SC', 'south dakota': 'SD', 'tennessee': 'TN',
          'texas': 'TX', 'utah': 'UT', 'vermont': 'VT', 'virginia': 'VA', 'washington': 'WA',
          'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY'
        };
        const normalized = stateName.toLowerCase().trim();
        return stateMap[normalized] || stateName.substring(0, 2).toUpperCase();
    };

    const barNumbers = statesWithLicenses
      .filter(ls => ls.barNumber && ls.barNumber.trim())
      .map(ls => `${getStateAbbreviation(ls.state)} Bar ${ls.barNumber}`)
      .join('   ');

    return `
      <div style="margin-bottom: 8px; font-size: 13px; color: #333;">
        <div>Licensed in ${stateNames}</div>
        ${barNumbers ? `<div>${barNumbers}</div>` : ''}
      </div>
    `;
  };

  return `
    <table cellpadding="0" cellspacing="0" style="font-family: Arial, sans-serif; font-size: 13px; line-height: 1.4;">
      <tbody>
        <tr>
          <td valign="middle" style="padding-right: 5px; padding-top: 10px;">
            <a href="https://kneuppercovey.com" style="text-decoration: none;">
              <img 
                src="https://kneuppercovey.com/wp-content/uploads/2024/01/logo_transparent-copy.png" 
                alt="Kneupper & Covey PC" 
                style="height: 80px; width: auto;" 
              />
            </a>
          </td>
          <td valign="top" style="padding-left: 2px;">
            <div style="margin-bottom: 8px;">
              <div style="font-family: Verdana, sans-serif; font-size: 19pt; font-weight: bold; color: #666; margin-bottom: 2px;">
                ${name || "Your Name"}
              </div>
              ${title ? `<div style="font-size: 14px; color: #333; margin-left: 4px;">${title}</div>` : ''}
            </div>
            <div style="height: 2px; background-color: #666; margin: 8px 0; width: 200px;"></div>
            ${renderLicensingInfo()}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding-top: 2px;">
            <div style="font-size: 13px; color: #666;">
              ${officePhone ? `<span style="font-weight: bold; font-style: italic;">Office</span> <a href="tel:${officePhone.replace(/[^\\d]/g, '')}" style="color: #333; text-decoration: underline;">${officePhone}</a>` : ''}
              ${mobilePhone ? `${officePhone ? "   " : ""}<span style="font-weight: bold; font-style: italic;">Mobile</span> <a href="tel:${mobilePhone.replace(/[^\\d]/g, '')}" style="color: #333; text-decoration: underline;">${mobilePhone}</a>` : ''}
              ${email ? `${(officePhone || mobilePhone) ? "   " : ""}<span style="font-weight: bold; font-style: italic;">Email</span> <a href="mailto:${email}" style="color: #333; text-decoration: underline;">${email}</a>` : ''}
            </div>
            <div style="font-size: 13px; color: #666; margin-top: 2px;">
              <span style="font-weight: bold; font-style: italic;">Mailing Address</span> <span style="color: #333;">${address || '11720 Amber Park Dr, Ste 160, PMB 1271, Alpharetta, GA 30009'}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  `;
};



export const copyToClipboard = async (html) => {
  try {
    const type = "text/html";
    const blob = new Blob([html], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    await navigator.clipboard.write(data);
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
  }
};



export const copyTextToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy text: ', err);
    return false;
  }
}; 